import Vue from "vue";
import ImgDetail from "./ImgDetail.vue";
const imgModal = Vue.extend(ImgDetail);
function showImg(url, type) {
  var modal = new imgModal({
    el: document.createElement("div"),
    data() {
      return {
        show: true,
        imgUrl: url,
        isVideo: type == "video" ? true : false,
        isAudio: type == "audio" ? true : false,
        isImage: type != "video" && type != "audio" ? true : false,
        title:
          type == "video"
            ? "查看视频"
            : type == "audio"
            ? "查看音频"
            : "查看图片",
      };
    },
    methods: {
      closeModal() {
        //   this.$emit("change", false);
        this.show = false;
        document.body.removeChild(modal.$el);
        // this.imgUrl = "";
        // this.show = false;
      },
      //   showModal(url) {
      //     this.imgUrl = url;
      //     this.show = true;
      //   },
    },
    beforeMount() {
      console.log("即将加载");
    },
  });

  document.body.appendChild(modal.$el);
}

function install() {
  Vue.prototype.ShowImg = showImg;
}
export default install;
